<h1 class="u-sr-only">{{ 'Profile.Menu.Dependents' | translate }}</h1>
<section class="c-section c-section--first u-no-pb" panel>
	<div class="c-section__header">
		<p class="c-section__title u-hidden@md-and-up">{{ 'Profile.Menu.Dependents' | translate }}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card">
					<div class="c-content u-no-ph">
						<div class="o-grid o-grid--wrap@up-to-md">
							<div *ngIf="vm.isInviteEnabled" class="o-grid__cell o-grid__cell--w-100 u-no-p u-hidden@up-to-md">
								<div class="c-content u-no-pv u-ost-md u-osb-md">
									<div>
										<item-invitation-dependent [(form)]="vm.form" [(dependent)]="vm.dependent"></item-invitation-dependent>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section *ngIf="vm.isInviteEnabled" class="c-section u-no-pb u-hidden@md-and-up" panel [isOpen]="true">
	<div class="c-section__header">
		<p class="c-section__title u-hidden@md-and-up">{{ 'Dependents.Invite_Dependent' | translate }}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card">
					<div class="c-content">
						<item-invitation-dependent [(form)]="vm.form" [(dependent)]="vm.dependent"></item-invitation-dependent>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="c-section c-section--last u-no-pb" panel>
	<div class="c-section__header">
		<p class="c-section__title u-hidden@md-and-up">{{ 'Dependents.Sent_Invitations' | translate }}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<card-dependents></card-dependents>
			</div>
		</div>
	</div>
</section>
